/*
 * ih.utils
 *
 * Stores functions that may be useful
 *
 * Depends:
 *      ih
 *
 */

    ih = ih || {};
    ih.utils = ih.utils || {};

    // select a range of text within an input (and focus it)
    // start and end are the indexes of the text string (the input value) that you want to select,
    // allowing you to select just a partial range
    // if no start and end arguments are provided, the entire value will be selected
    ih.utils.createInputTextSelection = function(field, start, end) {
        if (start == undefined && end == undefined) {
            start = 0;
            end = field.value.length;
        }
        setTimeout( function() {
            if( field.createTextRange ) {
                var selRange = field.createTextRange();
                selRange.collapse(true);
                selRange.moveStart('character', start);
                selRange.moveEnd('character', end);
                selRange.select();
                
                if ( field !== document.activeElement ) field.focus();
            }
            else if( field.setSelectionRange ) {
                if ( field !== document.activeElement ) field.focus();
                field.setSelectionRange(start, end);
            }
            else if( typeof field.selectionStart != 'undefined' ) {
                field.selectionStart = start;
                field.selectionEnd = end;
                if ( field !== document.activeElement ) field.focus();
            }
        }, 10);
    };

    // escapes special html characters from a string
    ih.utils.escapeHTML = function(text) {
        return text.replace(/\&/g,'&amp;').replace(/\</g,'&lt;').replace(/\>/g,'&gt;');
    };

    // strips out extra spaces and line breaks from a string
    // also trims off spaces from the ends.
    ih.utils.strip = function(text) {
        text = text.replace(/(\r\n|\n|\r)/gm," ");
        text = text.replace(/\s+/g," ");
        text = text.trim();
        return text;
    };
    
    // converts a string like a page title into a url slug format:
    // - remove non alpha-numeric characters, 
    // - convert spaces to dashes, 
    // - enforce lowercase
    // - force minimum 3 characters by adding dashes
    ih.utils.slugify = function(text, trim) {
//        text = ih.utils.strip(text);
        // don't trim unless explicitly asked for
        text = text.replace(/(\r\n|\n|\r)/gm," ");
        text = text.replace(/\s+/g," ");
        if ( trim ) {
            text = text.trim();
        }
        
        text = text.replace(/[^-a-zA-Z0-9_\s]+/ig, '');
        text = text.replace(/\s/gi, "-");
        text = text.toLowerCase();
        while (text.length < 3) {
            text += "-";
        }
        return text;
    };
    
    
    // converts a file size from bytes to friendly string units
    ih.utils.bytesToSize = function(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Bytes';
        function roundToTwo(num) {
            return +(Math.round(num + "e+2")  + "e-2");
        }
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
//        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        var number = ( i == 0 ) ?  Math.round(bytes / Math.pow(1024, i), 2) : roundToTwo(bytes / Math.pow(1024, i));
        return number + ' ' + sizes[i];
    };


    // converts a raw price to a formatted price string
    // currently strips decimals
    // e.g. 450000 -> $450,000
    //
    // TODO: set abbreviate to true to use a shortened price string
    // e.g. 450000 -> $450k, 2540000 -> $2.5m
    ih.utils.formatPrice = function(price, abbreviate) {
        
        var rawPrice = parseInt( price );   // integer
        var strPrice = rawPrice.toString(); // string
        
        if ( abbreviate ) {
            // millions
            if ( strPrice.length >= 7 ) {
                strPrice = ih.utils.toFixed(strPrice / 1000000, 1) + "m";
            }
            // thousands
            else if ( strPrice.length >= 4 ) {
                var p = ih.utils.toFixed(strPrice / 1000, 1);
                // if it rounds up to 1000. e.g. $999,999
                if (p >= 1000) {
                    strPrice = "1m";
                }
                else {
                    strPrice = p + "k";
                }
            }
        }
        else {
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(strPrice)) {
                strPrice = strPrice.replace(rgx, '$1' + ',' + '$2');
            }
        }
        
        return "$" + strPrice;
    };


    // The default `toFixed` function is mad, it can't round numbers correctly
    // The following one works much better
    ih.utils.toFixed = function(value, precision) {
        var multiplier = (precision ? Math.pow(10, precision) : 1);

        return parseFloat(
            Math.round(value * multiplier) / multiplier
        );
    };


    // PHP has a `preg_match_all` function, but JavaScript doesn't have any analogous one.
    // Whether you use `match` or `search`, you can't get a simple array of matching results.
    // This function returns an array with arrays of matches, just like the `preg_match_all` with a PREG_SET_ORDER flag.
    ih.utils.match = function(regex, string) {
        var result = [];

        string.replace(regex, function() {
            var matches = [arguments[0]];

            for (var i = 1; i < arguments.length - 2; i++) {
                matches.push(arguments[i]);
            }

            result.push(matches);
        });

        return result;
    };


    /**
     * Useful for when storing a stringified object (hash) in a data attribute
     * on a DOM element. We then grab that string value and convert it to an object.
     */
    ih.utils.strToJson = function(str, notevil) {
        try {
            if (notevil) {
                return JSON.parse(str
                    // wrap keys without quote with valid double quote
                    .replace(/([\$\w]+)\s*:/g, function(_, $1){return '"'+$1+'":';})
                    // replacing single quote wrapped ones to double quote
                    .replace(/'([^']+)'/g, function(_, $1){return '"'+$1+'"';})
                );
            } else {
                return (new Function("", "var json = " + str + "; return JSON.parse(JSON.stringify(json));"))();
            }
        } catch(e) { return false; }
    };


    /**
     * Just a wrapper around the native JSON.stringify()
     * Adds spaces to the stringified object.
     * Should be used for any string values we insert into data attributes 
     * and for any string values that are ultimately saved to the database
     * because if rendering via Smarty, it will attempt to parse a curly brace 
     * immediately followed by another non-whitespace character.
     */
    ih.utils.jsonToStr = function(obj) {
        try {
            return JSON.stringify(obj, null, 1);
        } catch(e) { return false; }
    };


    // Converts strings to the camel-case format.
    // This method looks for letters with spaces, dashes, or underscores before them and convert them to the upper case.
    // If the second argument set to TRUE, converts the first character to the upper case as well.
    ih.utils.camelize = function(str, first) {
        var regex = new RegExp('(?:'+ (first ? '^|' : '') +'-|_|\\s)+(\\w)', 'g');

        return str.replace(regex, function(match, letter) {
            return letter.toUpperCase();
        });
    };


    // Recursively replaces special tags in a given string with values from the `params` array.
    // Tags format: %%tag_name|default value%%.
    // If the default value is not set (%%tag_name%%) and there is no a replacement in the params,
    // the tag will be replaced with an empty string.
    // Example:
    // ih.utils.renderTemplate('<div id="%%id%%" class="%%class|my-div%%">%%span%%</div>', { id: 123, span: '<span>%%id%%</span>' })
    // will return '<div id="123" class="my-div"><span>123</span></div>'
    ih.utils.renderTemplate = function(str, params) {
        return String(str).replace(/%%(\w+)(?:\|(.+?))?%%/g, function(match, param, def) {
            var replacement = params[param];

            if (typeof replacement === 'undefined') {
                replacement = (typeof def !== 'undefined' ? def : '');
            }

            return ih.utils.renderTemplate(replacement, params);
        });
    };


    // Generates a unique numeric ID
    ih.utils.uniqueId = function() {
        if (!ih.utils._uniqueId) {
            ih.utils._uniqueId = (new Date()).getTime();
        }

        return String(ih.utils._uniqueId++);
    };
    
    
    // commonly used regex patterns
    // sample usage: count how many uppercase letters are in a password string
    //      var uc_count = password.length - (password.replace(ih.utils.regex.uppercase, "")).length;
    //
    ih.utils.regex = ih.utils.regex || {};
    ih.utils.regex.letters = /[a-z]*/ig;
    ih.utils.regex.lowercase = /[a-z]*/g;
    ih.utils.regex.uppercase = /[A-Z]*/g;
    ih.utils.regex.numbers = ih.utils.regex.digits = /[\d]*/g;
    ih.utils.regex.special_characters = /[~!@#%&_+={};:,<>\-\?\.\|\[\]\(\)\*\^\$]*/g;
    
    
    // commonly used strings/messages
    ih.utils.message = ih.utils.message || {};
    ih.utils.message.ajaxError = "The server is having problems. Please contact support.";
    
    
